import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTree, faMap, faAppleWhole } from "@fortawesome/free-solid-svg-icons";

interface MonitoringModeProps {
  mode: "FRUIT" | "TREE" | "BLOCK";
  setMode: (mode: "FRUIT" | "TREE" | "BLOCK") => void;
}

export const MonitoringMode: React.FC<MonitoringModeProps> = ({ mode, setMode }) => {
  return (
    <div className="d-flex justify-content-center align-items-center custom-toggle-switch-wrapper ">
      <div className="custom-toggle-switch">
        <button 
          className={`toggle-option ${mode === "TREE" ? 'active' : ''}`}
          onClick={() => setMode("TREE")}
        >
          <FontAwesomeIcon icon={faTree} className="me-2" />
          Arbre
        </button>
        <button 
          className={`toggle-option ${mode === "BLOCK" ? 'active' : ''}`}
          onClick={() => setMode("BLOCK")}
        >
          <FontAwesomeIcon icon={faMap} className="me-2" />
          Secteur
        </button>
        <button 
          className={`toggle-option ${mode === "FRUIT" ? 'active' : ''}`}
          onClick={() => setMode("FRUIT")}
        >
          <FontAwesomeIcon icon={faAppleWhole} className="me-2" />
          Fruit
        </button>
      </div>
    </div>
  );
};
